import script from "./NumberAdvanced.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumberAdvanced.vue?vue&type=script&lang=ts&setup=true"

import "./NumberAdvanced.vue?vue&type=style&index=0&id=0325de78&lang=scss&scoped=true"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0325de78"]])

export default __exports__